import React, { useCallback, useEffect, useState } from 'react';
import { bookingApi } from '../../../utils/bookingApi';
import { formatDate } from '../../../utils/dates';
import { PageHeader, Skeleton, ErrorState, InlineError } from '../../../components/ui';
import '../booking-shared.css';
import './adminTables.css';

const REASON_LABELS = { INACTIVITY: 'Inactive', MANUAL: 'Manual or GDPR' };

// Members deleted for good: only a summary of each is kept. Shown inside the
// member list (inline) or as a page of its own.
export default function AdminRemovedMembers({ inline = false }) {
  const [summaries, setSummaries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    setError(false);
    bookingApi.getArchivedMembers()
      .then(r => setSummaries(r.data))
      .catch(err => { console.error(err); setError(true); })
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  let table;
  if (loading) table = <Skeleton rows={2} label="Loading removed members…" />;
  else if (error) {
    table = inline
      ? <InlineError onRetry={load}>Couldn't load removed members.</InlineError>
      : <ErrorState title="Couldn't load removed members" onRetry={load} />;
  } else if (summaries.length === 0) table = <p className="bk-muted">No removed members yet.</p>;
  else {
    table = (
      <table className="bk-table ad-table">
        <thead>
          <tr>
            <th>Name</th>
            <th className="num">Sessions</th>
            <th className="num">Total paid</th>
            <th className="num">Memberships</th>
            <th>Reason</th>
            <th>Removed</th>
          </tr>
        </thead>
        <tbody>
          {summaries.map(s => (
            <tr key={s.id}>
              <td className="ad-card-title">{s.firstName} {s.lastName}</td>
              <td className="num" data-label="Sessions">{s.sessionsAttended}</td>
              <td className="num" data-label="Total paid">£{(s.totalAmountPaid / 100).toFixed(2)}</td>
              <td className="num" data-label="Memberships">{s.membershipCount}</td>
              <td data-label="Reason">{REASON_LABELS[s.deletionReason] ?? s.deletionReason}</td>
              <td className="ad-nowrap bk-muted" data-label="Removed">{formatDate(s.deletedAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  if (inline) return table;

  return (
    <div className="bk-page bk-page--wide">
      <PageHeader back={{ to: '/booking/admin/members', label: 'Members' }} title="Removed members" />
      {table}
    </div>
  );
}
